import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const fetchAll = async () => (await request.getInstance()).get(API_ROUTES.profession.fetchAll);
export const newItem = async data => (await request.getInstance()).post(API_ROUTES.profession.create, data);
export const editItem = async (id, data) => (await request.getInstance()).put(API_ROUTES.profession.change.replace(':id', id), data);
export const removeItem = async id => (await request.getInstance()).delete(API_ROUTES.profession.remove.replace(':id', id));
